import { View } from 'react-native';
import { LetterSquare } from './index';
import { useState } from 'react';
import { styles } from './styles';

export function LetterSquareContainer({ correctWord, emptySpaces }) {
  // calculate size and margin of letter boxes
  let size, marginLeft;
  const [maxSize, setMaxSize] = useState(1);
  const [fullWidth, setFullWidth] = useState(1);
  size = fullWidth / correctWord.length;
  marginLeft = fullWidth / 400;
  size = size - marginLeft;
  size = size * 0.98;
  size = Math.min(maxSize, size);

  const handleLayout = (event) => {
    const { width, height } = event.nativeEvent.layout;
    setMaxSize(height * 0.9);
    setFullWidth(width);
  };

  return (
    <View style={styles.blankedWrapper} onLayout={handleLayout}>
      {correctWord.map((eachLetter, index) => {
        const isEmpty = emptySpaces.includes(index);
        return (
          <LetterSquare
            key={index}
            size={size}
            marginLeft={marginLeft}
            letter={eachLetter}
            isEmpty={isEmpty}
          />
        );
      })}
    </View>
  );
}
